@if (appReady) {
	<pkd-navbar [useAltHeader]="appStateService.useAltHeader" [removeNav]="appStateService.removeNav"></pkd-navbar>
}

<router-outlet></router-outlet>

@if (appReady) {
	<pkd-footer [useAltFooter]="appStateService.useAltHeader"></pkd-footer>
}
